import { IModel } from "../ModelStoring/Model";
import { BindingPath } from "../CoreTypes";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";

export const KREC_ERROR_CHECK = "KREC_ERROR_CHECK";
export const KREC_ERROR_CONVERT = "KREC_ERROR_CONVERT";

export const errorsFallback: { [key in string]: undefined | string } = {
    [KREC_ERROR_CHECK]:
        "Не удалось проверить документ на соответствие требованиям ФНС." +
        "Проверьте вручную или загрузите ещё раз в течение часа",
    [KREC_ERROR_CONVERT]:
        "Не удалось привести документ в соответствие требованиям ФНС." +
        "Исправьте вручную или загрузите ещё раз в течение часа",
};

type ErrorType = "error" | "warning";

export interface IErrorManager {
    addErrorCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, message: string): void;
    addWarningCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, message: string): void;
    clearErrorsCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath): void;
    clearWarningsCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath): void;
    clearCached(model: IModel, path: BindingPath | AbsoluteResolvedModelPath): void;
    removeWarning(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, message: string): void;
}

export class ErrorManager implements IErrorManager {
    public clearErrorsCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath): void {
        return this.internalClear(model, nodePath, "error");
    }

    public clearWarningsCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath): void {
        return this.internalClear(model, nodePath, "warning");
    }

    public addErrorCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, message: string): void {
        return this.internalAdd(model, nodePath, message, "error");
    }

    public addWarningCached(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, message: string): void {
        this.internalAdd(model, nodePath, message, "warning");
    }

    public removeWarning(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, message: string): void {
        return this.internalRemove(model, "warning", nodePath, message);
    }

    public clearCached(model: IModel, path: BindingPath | AbsoluteResolvedModelPath): void {
        this.clearErrorsCached(model, path);
        this.clearWarningsCached(model, path);
    }

    private internalClear(model: IModel, nodePath: BindingPath | AbsoluteResolvedModelPath, type: ErrorType): void {
        const nodeData = model.getViewModel(nodePath);

        if (!nodeData) {
            return;
        }
        const items = nodeData[type];
        if (!items) {
            return;
        }
        model.setViewModelField(nodePath, type, []);
    }

    private internalAdd(
        model: IModel,
        nodePath: BindingPath | AbsoluteResolvedModelPath,
        message: string,
        type: ErrorType
    ): void {
        const nodeData = model.getViewModel(nodePath);

        if (nodeData !== undefined) {
            model.setViewModelField(nodePath, type, [message]);
        }
    }

    private internalRemove(
        model: IModel,
        type: ErrorType,
        nodePath: BindingPath | AbsoluteResolvedModelPath,
        message: string
    ): void {
        let nodeData = model.getViewModel(nodePath);
        if (nodeData === undefined) {
            nodeData = {};
        }
        const container = nodeData[type] ?? [];
        const msgIdx = container.lastIndexOf(message);

        if (msgIdx !== -1) {
            const newContainer = container.slice(0);
            model.setViewModelField(nodePath, type, newContainer);
        }
    }
}
